import React from 'react';
import aboutImage from '../assets/images/about1.jpg'; // 실제 경로에 맞게 수정하세요
import aboutImage2 from '../assets/images/about2.jpg';
import aboutImage3 from '../assets/images/about3.jpg';

export default function AboutSection() {
  return (
    <section className="px-[15vw] py-12">
      <div className="max-w-[70vw] mx-auto">
        {/* 이미지 */}
        <div className="w-full h-[300px] overflow-hidden mb-0">
          <img
            src={aboutImage}
            alt="회사 소개 이미지"
            className="w-full h-full object-cover object-center"
          />
        </div>

        {/* 회사소개 텍스트 */}
        <div className="w-full bg-black text-white text-center py-4 rounded-b-md font-nanumgothic">
          <h2 className="text-2xl font-bold m-0">회사소개</h2>
        </div>
        <p className="mt-20 mb-20 text-center text-sm leading-relaxed whitespace-pre-line px-6">
          {`라이프스팬 뉴질랜드는 뉴질랜드산 고품질의 천연 영양제를 생산합니다. 
          저희는 과학적으로 입증된 안전하고 효과적인 성분을 사용해 고객님들의 건강에 도움을 드리는 것을 최우선으로 생각합니다. 
          무엇보다도 건강에 도움이 된다고 확신하지 않는 제품은 판매하지 않을 것입니다. 그것이 최고 인기제품이라도 말이죠.
          
          저희는 전 세계에 저희 제품을 판매하는 공급처들과 우수한 고객서비스의 기록을 가지고 있습니다. 
          그리고 여러분도 그 중 한 명이 될 수 있습니다.`}
        </p>

        {/* 하단 코멘트 박스들 */}
        <div className="mt-12 flex flex-col md:flex-row gap-6 md:divide-x md:divide-gray-300 font-nanumgothic">
          <div className="flex-1  p-6 text-center font-semibold">
            <h2 className="text-xl font-black py-4 px-0">확실한 전문성</h2>
            <p className="my-10 text-center text-sm leading-relaxed whitespace-pre-line px-6 font-nanumgothic">
              {`본사의 천연 영양보충제는 최첨단 추출법과 가공법을 사용해 생산됩니다. 이는 원료들이 건강에 최대한 도움이 되도록 효과를 유지하게 만들어줍니다.

            저희는 최고의 품질을 가진 제품을 위해 계속해서 연구하고 혁신성을 추구하는 등, 생산과 보완에 대해 책임감과 윤리 의식을 가지고 접근합니다.`}
            </p>
          </div>
          <div className="flex-1  p-6 text-center font-semibold">
            <h2 className="text-xl font-black py-4 px-0">고객 관리</h2>
            <p className="my-10 text-center text-sm leading-relaxed whitespace-pre-line px-6 font-nanumgothic">
              {`제품 구매에 관한 정보, 혹은 수입이나 판매에 대한 문의가 있다면 이메일을 보내주세요.

                전 세계로의 배송과 통관을 돕고 있습니다.
                
                📧 admin@purelifespanworld.com`}
            </p>
          </div>
        </div>
        {/* 두번째 소개 섹션 */}
        {/* 이미지 */}
        <div className="w-full h-[300px] overflow-hidden mb-0">
          <img
            src={aboutImage2}
            alt="회사 소개 이미지"
            className="w-full h-full object-cover object-center"
          />
        </div>
        <div className="w-full bg-black text-white text-center py-4 rounded-b-md font-nanumgothic">
          <h2 className="text-2xl font-bold m-0">우리의 책무</h2>
        </div>
        <p className="mt-20 mb-20 text-center text-sm leading-relaxed whitespace-pre-line px-6">
          {`저희는 육지와 바다 모두에 특별한 관계를 가지고 있습니다. 
          보살핌과 존중, 그리고 자연이 번성할 수록 우리도 번성한다는 근본적인 이해를 기반으로 하고 있습니다.

          뉴질랜드의 넓은 해안선과 청량한 물이 어우러진 결과는 매우 훌륭합니다. 
          그것은 바로 믿을 수 있는 나라와 사람으로부터 생산된 세계 최고 수준의 영양가 높은 재료입니다.`}
        </p>

        {/* 하단 코멘트 박스들 */}
        <div className="mt-12 flex flex-col md:flex-row gap-6 md:divide-x md:divide-gray-300 font-nanumgothic">
          <div className="flex-1  p-6 text-center font-semibold">
            <h2 className="text-xl font-black py-4 px-0">지속성</h2>
            <p className="my-10 text-center text-sm leading-relaxed whitespace-pre-line px-6 font-nanumgothic">
              {`지속성은 저희 회사의 핵심가치입니다. 마오리 원칙인 카이티아키탕가에 따라, 우리는 현재와 미래의 세대를 위해 육지와 바다, 그리고 우리들을 지키기 위한 노력을 계속하고 있습니다. 말하자면, 저희의 약속은 단순히 환경에 주는 영향을 줄이는 것만이 아니라, 변화를 이끌어 가겠다는 것이기도 합니다.`}
            </p>
          </div>
          <div className="flex-1  p-6 text-center font-semibold">
            <h2 className="text-xl font-black py-4 px-0">식품 안전</h2>
            <p className="my-10 text-center text-sm leading-relaxed whitespace-pre-line px-6 font-nanumgothic">
              {`식품 안전은 뉴질랜드의 식품 생산자들에게 가장 중요한 것입니다. 
              따라서, 라이프스팬은 엄격한 식품위생 기준과 관례을 가지고 있습니다. 
              마찬가지로, 저희는 최고 품질의 제품만을 유통할 수 있도록 첨단 기술과 품질 관리에 심혈을 기울입니다.`}
            </p>
          </div>
        </div>

        {/* 세번째 소개 섹션 */}
        {/* 이미지 */}
        <div className="w-full h-[300px] overflow-hidden mb-0">
          <img
            src={aboutImage3}
            alt="회사 소개 이미지"
            className="w-full h-full object-cover object-center"
          />
        </div>
        <div className="w-full bg-black text-white text-center py-4 rounded-b-md font-nanumgothic">
          <h2 className="text-2xl font-bold m-0">해양 생물 자원에 대한 보호</h2>
        </div>
        <p className="mt-20 mb-20 text-center text-sm leading-relaxed whitespace-pre-line px-6">
          {`귀중한 자원에 대한 지속 가능한 관리는 마오리족의 카이티아키탕가, 즉 보호자정신의 개념으로 이 산업의 핵심입니다. 
          이는 사람이 바다와 함께 일하는 지침을 주고, 그 보상은 다음 세대를 위해 보존되는 것을 뜻합니다.

          저희는 항상 해양 환경에 미치는 영향을 최소화하기 위해 노력하고 있습니다.`}
        </p>
      </div>
    </section>
  );
}
